export default (): number => {
  return window.innerWidth - document.documentElement.clientWidth;
};
